import React from "react";
import { Icon } from "@chakra-ui/react";
import { MdHome } from "react-icons/md";
import { IoHeart, IoSettingsSharp } from "react-icons/io5";
import { FaEyeSlash } from "react-icons/fa";
import { IoMdCart } from "react-icons/io";
import { IoCalendarSharp } from "react-icons/io5";
import { CiCreditCardOff } from "react-icons/ci";

import MainDashboard from "views/admin/default";
import vendus from "views/admin/prodPlusVendus";
import Properimes from "medicProperimes";
import Profile from "views/admin/profile";
import MasterPass from "views/auth/MasterPass";
import Settings from "views/admin/Settings";
import Favoris from "views/admin/favourite";
import Masked from "views/admin/masked";
import SignInCentered from "views/auth/signIn";
import WithoutDatePeremption from 'views/admin/without_datePeremption'
import ProfileHistory from "views/admin/profile/profileHistory"
import ForgotPassword from "views/auth/forgotPassword";
import ResetMasterPassword from "views/auth/resetMasterPassword";
import PointsConfig from "views/admin/pointsConfig";
import QuickSellConfig from "views/admin/quickSellConfig";
import Challenges from "views/admin/challenges";
import ConfigProPerime from "views/admin/configProPerime";
import PointsConversion from "views/admin/pointsConversion";

const routes = [
  {
    name: "Tableau de bord",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: MainDashboard,
  },
  {
    name: "Produits les plus vendus",
    layout: "/admin",
    path: "/produits-vendus",
    icon: <Icon as={IoMdCart} width="20px" height="20px" color="inherit" />,
    component: vendus,
    secondary: true,
  },
  {
    name: "Produits favoris",
    layout: "/admin",
    icon: <Icon as={IoHeart} width="20px" height="20px" color="inherit" />,
    path: "/produits-favoris",
    component: Favoris,
  },{
    name: "Produits sans date de péremption",
    layout: "/admin",
    icon: <Icon as={CiCreditCardOff} width="20px" height="20px" color="inherit" />,
    path: "/produits-sans-date_peremption",
    component: WithoutDatePeremption,
  },
  {
    name: "Produits masqués",
    layout: "/admin",
    icon: <Icon as={FaEyeSlash} width="20px" height="20px" color="inherit" />,
    path: "/produits-masques",
    component: Masked,
  },
  {
    name: "Produits pro-périmés",
    layout: "/admin",
    path: "/produits-properimes",
    icon: (
      <Icon as={IoCalendarSharp} width="20px" height="20px" color="inherit" />
    ),
    component: Properimes,
    secondary: true,
  },
  {
    name: "Paramètres",
    layout: "/admin",
    path: "/settings",
    icon: <Icon as={IoSettingsSharp} width="20px" height="20px" color="inherit" />,
    component: Settings,
  },
  {
    name: "Configuration Pro-Périmé",
    layout: "/admin",
    path: "/config-pro-perime",
    component: ConfigProPerime,
  },
  {
    layout: "/admin",
    path: "/points-config",
    component: PointsConfig,
  },
  {
    layout: "/admin",
    path: "/quick-sell-config",
    component: QuickSellConfig,
  },
  {
    layout: "/admin",
    path: "/profile",
    component: Profile,
  },
  {
    layout: "/admin",
    path: "/masterpass",
    component: MasterPass,
  },
  {
    layout: "/auth",
    path: "/sign-in",
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    name: "Reset Master Password",
    layout: "/auth",
    path: "/reset-master-password/:token",
    component: ResetMasterPassword,
  },
  {
    layout: "/admin",
    path: "/historique-vente",
    component: ProfileHistory,
  },
  {
    layout: "/admin",
    path: "/challenges",
    component: Challenges,
  },
  {
    layout: "/admin",
    path: "/points-conversion",
    component: PointsConversion,
  },
];

export default routes;
